"use client";

import type { FC } from "react";
import { AppImage } from "@/src/components/NextImage";
import { ONBOARDING_WIZARD_ASSETS } from "../onboardingWizardAssets";

/** Figma Group 2147235392 — headline decorative circle + ed: logo watermark */
export const ValuePropHeadlineWatermark: FC = () => (
  <div
    className="pointer-events-none absolute top-0 right-[-58px] size-[174px] md:right-0"
    aria-hidden
    data-testid="value-prop-headline-watermark"
    data-figma-node="Group 2147235392"
  >
    <AppImage
      src={ONBOARDING_WIZARD_ASSETS.valuePropWatermark}
      alt=""
      width={174}
      height={174}
      className="size-full"
      loading="eager"
    />
  </div>
);
